var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_52",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_52)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.88,
    y: 3.59998,
    width: 29.52,
    height: 28.8,
    fill: "#2D89FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_52",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_52",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAEn0lEQVR4nO2dy29VRRzHP9JCrylBCCyg10QeWnZA2AKRVHQrLsCEx07UBIgagnVp4oaEDWnCX8AfQCILDURduNAYDBY2wAIM4aHyaBUIvdjbspgDIddz8Dfvc6bzSX65STPnnu98M/ecmd88CplMJpPJZDKZTCZTU16KLaCEPmAjsA5YCwwDq4FBYEnxCfAQmCg+rwCXgMvAOHAO6AZV3RBeBT4FTgF/A7OWMQl8DXwCtAPWo5a8DOwFzqBan625VTENnAb2AK0gNasJC1Et7Qb+zK2Kv4AvgVe81zIi84HDwF3CG9wbd4FDhaak2AJcIL7BvXER2Oax3sFoAceBGeKbWhUzwBgw4MkD76wEfia+kdL4FXjdixMe2YabblromARGPPjhhfeAR8Q3zTQ6wPvOXXHMh/jtE4eKLrDPsTfO2I4aHMQ2yaXZO5065IARYIr45riODvCOQ5+seINmvvikMQmsceaWIQOoblFsM3zHWSL3s4+XiPIVHeBzYKiI0eJvoe4/5sgzbd4k7IhvtETDaMD7zwCbjd0ypB+VYA9VyVlgRYmO5YE1XCBwIuqwh0r8X1QRWsdn2m4ZshC4E6BCdTX6TuGBFvN0LwD2A0sNrkuFpcBHvm/SAm4SvhXVqUXPArdQU3FidFv0TspfSnON5ajkmRhdo/dqlk8Zb160iZs0qiKWni4aSxl0WvQO1OKWjGIeGo8PHaPf0teSPOLZGOmSsD5U/3GxkRw3VGl90WPFN5PAMgTLz6QteiNxTa4ri4ENkoJSo9eba0medZJCUqOHLYSkjsgbqdFrLYSkjsgbqdErLYSkzipJIanRiyyEPEYl6NuonoNpVGHznW3gi0KjKU5XptqkRctmRuqGzUzNbZdCbObmmpCEspmpmZLcwCQfrUsd98n04j21IDX6vsU9mpDxs9Fo481/uIr5T6uDegYOuRTkCBfLFq64FBR6xrssqoit65zEQOmj43dhubnIVUkhqdGXLISkjsibbLQ9To0+byEkdUTe5MS/Hc4T/13gRxtFifIDws39OiPD78y0JI3YE53h8RBwjXgz4XV7dHRRpzL8ISms06JvAt+bKEqUMwhNBv2k0gnN8inj1YsWcY5/qNsQ3PsixyngmOY1KXIUtTvYK4OoWYW52qKDLUR/CBwxuC4VvgIehLpZP/AbYVtSWT67HViD8WYh06msaeAgL/5Ju6ZsFiTk7M0s8DHwb8B7PmOMcK3p+ZmaGBs6o3YCBlDbd0P+fGPEL8ACR54ZswaVxYpthq+YQLgaKQRbafapM1XRAd526JMT3iW9g1F2OHXIIftI46ifaeADx944ZzvNfoxMUcMjfqoYoZkvyAnU+6ZRvAb8RHzzpHGWGhzpY8oAalBT9yMzj1GDfrILNlOPZWW9MQ5s8ljvKPSjDhWJkWLtjduoM6z7vdY4MoOoSl4nvMF/og7qttkq0jhawG7gW/wOdKaBb4BdzLGj58tYARwATgL3sDf3XvFd+1HbJqJTx20PfaiduhtQmyWHUUmdRaglaU+nkR6g+ur/oJbOXkYtOBwvIv97kEwmk8lkMplMJpOR8AT05QvqlfL45QAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroGroup);
export default __webpack_public_path__ + "static/media/hero-group.ab72fc05cc6a9e933df0675469a9b99e.svg";
export { ForwardRef as ReactComponent };